import type { ImageProps, Slide } from '@features/powerpoint';
import { type ImageWithMetadata, resizeToHeight } from '@features/powerpoint';
import { inmarketLogoV2 } from '@features/powerpoint/images';
import { contentSlideBackgroundV2, titleSlideBackgroundV2 } from '../images';
import { themeV2 } from '../domain/theme-v2';
import { DEFAULT_FONT } from '../utils/constants-v2';
import type { CampaignWithCalculatedFields } from '@components/Dashboard/hooks/useCampaign';

const TITLE_FONT_SIZE = 44;
const SUBTITLE_FONT_SIZE = 16;
const BRAND_LOGO_HEIGHT = 1.15;
const BRAND_LOGO_Y_POSITION = 2.15;

type TitleSlideV2Props = {
  campaign: Pick<CampaignWithCalculatedFields, 'id' | 'name'>;
  brandLogo?: ImageWithMetadata | null;
};

const buildBrandLogoImage = (
  brandLogo: ImageWithMetadata | null | undefined
): ImageProps[] => {
  if (!brandLogo) return [];

  const resized = resizeToHeight(brandLogo, BRAND_LOGO_HEIGHT, 1.11);
  const yPosition =
    resized.height < BRAND_LOGO_HEIGHT
      ? BRAND_LOGO_Y_POSITION + (BRAND_LOGO_HEIGHT - resized.height) / 2
      : BRAND_LOGO_Y_POSITION;

  return [
    {
      data: resized.data,
      x: 0.45,
      y: yPosition,
      w: resized.width,
      h: resized.height,
    },
  ];
};

export const titleSlideV2 = (props: TitleSlideV2Props): Slide => ({
  images: [
    {
      x: 0,
      y: 0,
      w: '100%',
      h: '100%',
      path: contentSlideBackgroundV2,
    },
    {
      x: 6.91,
      y: 0.3,
      w: 6.1,
      h: 6.92,
      path: titleSlideBackgroundV2,
    },
    {
      x: 0.45,
      y: 1.51,
      w: 1.87,
      h: 0.33,
      path: inmarketLogoV2,
    },
    ...buildBrandLogoImage(props.brandLogo),
  ],
  texts: [
    {
      text: [
        {
          text: 'Measurement',
          options: {
            fontSize: TITLE_FONT_SIZE,
            fontFace: DEFAULT_FONT,
            bold: true,
            color: themeV2.colors.metricBlue,
            breakLine: true,
          },
        },
        {
          text: 'Report',
          options: {
            fontSize: TITLE_FONT_SIZE,
            fontFace: DEFAULT_FONT,
            bold: true,
            color: themeV2.colors.metricBlue,
          },
        },
      ],
      options: {
        h: 5,
        w: 11.5,
        x: 0.33,
        y: 1.87,
        lineSpacing: 40,
      },
    },
    {
      text: [
        {
          text: props.campaign.name,
          options: {
            fontSize: SUBTITLE_FONT_SIZE,
            fontFace: DEFAULT_FONT,
            color: themeV2.colors.metricBlue,
            bold: true,
            breakLine: true,
          },
        },
        {
          text: `${props.campaign.id}`,
          options: {
            fontSize: SUBTITLE_FONT_SIZE,
            fontFace: DEFAULT_FONT,
            color: themeV2.colors.metricBlue,
            bold: true,
          },
        },
      ],
      options: {
        h: 1.25,
        w: 11.5,
        x: 0.33,
        y: 5.02,
        lineSpacing: 20,
      },
    },
  ],
});
